// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2siSv","label":"styles_label__1Q0yt"};